/* ==========================================================================
   CASEMIRA · LE SOCLE DES RAILS · LE MOUVEMENT QUE DEUX SURFACES PARTAGENT
   Fichier : assets/casemira-rail.js · 09/09/2026, chantier 7.

   CE FICHIER N'EST PAS UNE COPIE, C'EST UNE EXTRACTION. Tout ce qui suit vient
   de `assets/casemira-home-motion.js`, au caractere, et lui a ETE RETIRE. Il
   n'existe qu'un seul exemplaire de chaque geste dans le theme : la page
   d'accueil charge les deux fichiers (`snippets/casemira-home-socle.liquid`,
   celui-ci d'abord), la fiche produit ne charge que celui-la.

   POURQUOI. Les deux rails de la fiche produit - « Vous aimerez aussi » et
   « Recemment consultes » - doivent se comporter EXACTEMENT comme le rail des
   best-sellers de l'accueil (demande de Raph du 09/09 a 14 h 23) : memes
   fleches, meme jauge, meme cascade, meme tirage a la souris. Recopier le
   fichier de l'accueil sur la fiche etait exclu ; recopier les quatre gestes
   utiles l'etait tout autant, parce que deux copies divergent au premier
   correctif.

   CE QUE LE SOCLE EMPORTE, ET DANS L'ORDRE OU IL S'EXECUTAIT :
     · 3 · COMPOSITION      les titres se decoupent en mots
     · 1, 2, 4 · L'ENTREE   l'observateur unique, son filet, et le repli
     · les chevrons du theme
     · les rails            fleches, jauge, mesure, remise a zero
     · le tirage a la souris et le passage des images en `eager`

   CE QU'IL LAISSE : tout ce qui nomme un bloc de l'accueil. Le bon format, les
   scenes, les videos, les cinemagraphes, la parallaxe, le comparateur, le rail
   cinema, les declinaisons, les questions, la note ⓘ, le mur d'avis et le
   chargement tardif restent dans `casemira-home-motion.js`.

   DEUX GESTES SONT PARTAGES SANS ETRE DUPLIQUES : le tirage a la souris et le
   passage en `eager` valent aussi pour `.insta__piste`, `.scenes`, `.avis3` et
   `.mur-avis`, qui n'existent que sur l'accueil. Ils sont ECRITS ici, une fois,
   et exposes par `window.__cmhRail` ; `casemira-home-motion.js` les appelle
   pour ses propres elements, a l'endroit exact ou il le faisait hier. L'ordre
   de montage de chaque famille est donc celui d'avant.

   L'ORDRE DES DEUX FICHIERS EST UNE CONDITION : ce fichier declare les chevrons
   et l'API, `casemira-home-motion.js` les lit. Il est pose en premier, et les
   deux sont en `defer`, donc executes dans l'ordre du document.
   ========================================================================== */
(function () {
  'use strict';

  /* La meme garde que le fichier de l'accueil, pour la meme raison : chaque
     section qui a besoin du socle le demande, le navigateur ne le telecharge
     qu'une fois mais l'executerait N fois. */
  if (window.__cmhRailFait) return;
  window.__cmhRailFait = true;

  var doux = window.matchMedia('(prefers-reduced-motion: reduce)');
  var natif = window.CSS && CSS.supports && CSS.supports('animation-timeline', 'view()');

  /* LE CHEVRON DU THEME, declare ICI et non plus au-dessus des rails :
     depuis la v2 du bon format, le rail des scenes s'en sert lui aussi, et
     il s'execute avant. Un `var` est hisse mais pas sa valeur : declare plus
     bas, il aurait peint deux boutons vides sans lever la moindre erreur. */
  var SVG_G = '<svg viewBox="0 0 9 15" fill="none" aria-hidden="true"><path d="M7.5 1 1.5 7.5l6 6.5" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var SVG_D = '<svg viewBox="0 0 9 15" fill="none" aria-hidden="true"><path d="M1.5 1l6 6.5-6 6.5" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  /* Le rail se tire aussi à la souris. Un glissement n'est pas un clic : on
     annule le clic qui suivrait un déplacement de plus de 6 px.

     LOT v7, POINT 9 (Raph, 07/09 14 h 49) · « LES CARTES DE MODELES NE SONT PAS
     CLIQUABLES SUR ORDINATEUR, ELLES LE SONT SUR MOBILE. »
     LA CAUSE ETAIT ICI, ET ELLE VALAIT POUR TOUS LES RAILS DE LA PAGE. Ce
     gestionnaire prenait la CAPTURE DU POINTEUR des le `pointerdown`. Or une
     capture retarge aussi les evenements de compatibilite souris : le `click`
     qui suit n'est plus envoye au lien vise mais au RAIL, et aucune carte de ce
     rail ne pouvait plus etre suivie a la souris. Au doigt, le gestionnaire
     s'arrete a la premiere ligne (`pointerType !== 'mouse'`) : il n'y avait donc
     pas de capture, et les cartes marchaient. D'ou l'exact ecart decrit par
     Raph.
     Mesure avant correctif, Chromium 1440, trois points de la carte de modele et
     un point de tuile de piece : « navigation : NON » partout ; le meme essai en
     neutralisant `setPointerCapture` : « navigation : OUI ».
     LE CORRECTIF NE RETIRE PAS LA CAPTURE, IL LA RETARDE. Elle sert a garder le
     glissement quand la souris sort du rail : on la prend au premier vrai
     mouvement, au-dela des 6 px qui separent deja un glissement d'un clic. Un
     clic n'atteint donc jamais ce seuil et n'est jamais retarge.
     Le glissement natif d'image et de lien est refuse pendant le geste, sinon le
     navigateur emporterait la carte au lieu de tirer le rail. */
  function tirer(rail) {
    if (rail.scrollWidth <= rail.clientWidth && !rail.classList.contains('rail')) return;
    var tire = false, x0 = 0, s0 = 0, bouge = 0, pris = 0;
    rail.addEventListener('pointerdown', function (ev) {
      if (ev.pointerType !== 'mouse') return;
      if (ev.target.closest('button')) return;
      /* Le rail cinéma n'est plus un défilement : le tirer déplacerait un
         `scrollLeft` que plus rien ne remet à zéro, et le ruban partirait de
         travers. La garde est ici, à l'instant du geste, parce que le mode
         cinéma s'installe après ce bloc et peut s'en aller au redimensionnement. */
      if (rail.parentNode && rail.parentNode.hasAttribute && rail.parentNode.hasAttribute('data-cine')) return;
      tire = true; bouge = 0; pris = 0; x0 = ev.clientX; s0 = rail.scrollLeft;
    });
    rail.addEventListener('pointermove', function (ev) {
      if (!tire) return;
      var d = ev.clientX - x0; bouge = Math.max(bouge, Math.abs(d));
      if (bouge > 6 && !pris) {
        pris = ev.pointerId;
        try { rail.setPointerCapture(ev.pointerId); } catch (e) { pris = 0; }
      }
      if (bouge > 6) rail.scrollLeft = s0 - d;
    });
    rail.addEventListener('dragstart', function (ev) { if (tire && bouge > 6) ev.preventDefault(); });
    var fin = function (ev) {
      if (!tire) return;
      tire = false;
      if (bouge > 6) {
        var stop = function (e) { e.preventDefault(); e.stopPropagation(); };
        rail.addEventListener('click', stop, { capture: true, once: true });
        setTimeout(function () { rail.removeEventListener('click', stop, true); }, 0);
      }
      if (pris) { try { rail.releasePointerCapture(pris); } catch (e) {} pris = 0; }
    };
    rail.addEventListener('pointerup', fin);
    rail.addEventListener('pointercancel', fin);
  }

  /* Un rail qui approche du cadre passe ses images en `eager` : sans cela, une
     photo qui n'entre jamais dans la fenêtre au défilement VERTICAL n'est
     jamais demandée, et le rail se pousse sur du vide. */
  /* UN SEUL OBSERVATEUR POUR LES DEUX FICHIERS, cree au premier appel : c'est
     celui d'hier, et il ne se dedouble pas parce que l'accueil appelle cette
     fonction pour ses tuiles au lieu d'en construire un second. */
  var ior = null;
  function eager(el) {
    if (!('IntersectionObserver' in window)) return;
    if (!ior) {
      ior = new IntersectionObserver(function (entrees) {
        entrees.forEach(function (en) {
          if (!en.isIntersecting) return;
          en.target.querySelectorAll('img[loading="lazy"]').forEach(function (i) { i.loading = 'eager'; });
          ior.unobserve(en.target);
        });
      }, { rootMargin: '400px 0px' });
    }
    ior.observe(el);
  }

  /* L'API DU SOCLE. Trois entrees, et pas une de plus :
       · `chevrons` le dessin des fleches du theme, declare ci-dessus ;
       · `tirer`    le tirage a la souris, pour un element ;
       · `eager`    le passage des images d'un element au chargement immediat ;
       · `monter`   le montage complet sur une racine qui vient d'arriver.
     Elle est posee AVANT toute garde : `casemira-home-motion.js` la lit, et il
     ne doit jamais tomber sur `undefined`, meme sur une page sans `.cmh`. */
  window.__cmhRail = {
    chevrons: { g: SVG_G, d: SVG_D },
    tirer: tirer,
    eager: eager,
    monter: function (r) { if (r && r.nodeType === 1) demarrer(r); }
  };

  /* CE QUI ARRIVE APRES COUP. L'accueil pose ses corps de section par la
     Section Rendering API et annonce `cm:differe:charge` ; la fiche produit
     pose ses deux rails par le meme moyen et annonce `cm:rail:monte`. Les deux
     evenements portent la meme charge utile : la racine `.cmh` a monter. */
  function surArrivee(ev) {
    var racine = ev && ev.detail && ev.detail.racine;
    if (racine && racine.nodeType === 1) demarrer(racine);
  }
  document.addEventListener('cm:differe:charge', surArrivee);
  document.addEventListener('cm:rail:monte', surArrivee);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { demarrer(); });
    return;
  }
  demarrer();

  function demarrer(racine) {

  /* LA PORTÉE. Une seule fonction de recherche, et elle préfixe toujours
     `.cmh` : aucune requête de ce fichier ne peut atteindre le héros, le
     menu, le pied de page ni une section publiée.

     AVEC UNE RACINE, le prefixe saute et la recherche se fait DANS la section
     recue : la racine EST le `.cmh`, donc ses descendants sont exactement ceux
     que `.cmh <sel>` aurait rendus, et rien d'autre de la page ne peut entrer. */
  function qsa(sel) {
    if (racine) {
      return [].slice.call(racine.querySelectorAll(sel));
    }
    /* Un SEUL `querySelectorAll` pour tous les morceaux du sélecteur, et pas
       une boucle qui les concatène : le geste 6 · JOINTURE lit le fond du bloc
       PRÉCÉDENT, donc il lui faut l'ordre du document, pas l'ordre des
       sélecteurs. Concaténer aurait rendu tous les `.sect` puis tous les
       `.manif`, et la phrase de marque aurait cessé de couper la chaîne. */
    var pref = sel.split(',').map(function (s) { return '.cmh ' + s.trim(); }).join(',');
    return [].slice.call(document.querySelectorAll(pref));
  }
  if (!racine && !document.querySelector('.cmh')) return;

  /* ================================================================ 3 · MOTS
     Les titres de section se composent MOT À MOT, comme l'accroche de la
     bannière publiée. On marche les nœuds de texte pour ne pas perdre les
     `<em>` : chaque mot devient `<span class="mot"><i>mot</i></span>`, et
     `--m` porte son rang, donc son décalage. */
  function decouper(titre) {
    if (titre.querySelector('.mot')) return;
    var rang = 0;
    (function marcher(noeud) {
      var enfants = [].slice.call(noeud.childNodes);
      enfants.forEach(function (n) {
        if (n.nodeType === 1) return marcher(n);
        if (n.nodeType !== 3 || !n.textContent.trim()) return;
        var frag = document.createDocumentFragment();
        n.textContent.split(/(\s+)/).forEach(function (bout) {
          if (!bout) return;
          if (!bout.trim()) { frag.appendChild(document.createTextNode(bout)); return; }
          var mot = document.createElement('span');
          mot.className = 'mot';
          mot.style.setProperty('--m', rang++);
          var i = document.createElement('i');
          i.textContent = bout;
          mot.appendChild(i);
          frag.appendChild(mot);
        });
        n.parentNode.replaceChild(frag, n);
      });
    })(titre);
  }
  var titres = qsa('h2.tt');
  titres.forEach(decouper);

  /* ============================================== 1, 2, 4 · CE QUI SE DÉCLENCHE
     Un seul observateur pour tout ce qui s'allume à l'entrée : la composition
     des titres (qui ne passe jamais par `view()`, parce qu'un décalage par
     mot n'a pas de sens sur une chronologie de défilement),
     les silhouettes qui se tracent, les barres d'avis, les icônes de garantie,
     le ken-burns du manifeste, et le repli des révélations et des poses quand
     `view()` manque. */
  /* `[data-cascade]` n'est PAS dans le repli : une grille de cartes passe
     toujours par l'observateur, avec ou sans `view()`, parce qu'une
     chronologie de défilement ne sait pas décaler deux cartes d'une même
     rangée (elles entrent à la même hauteur, donc au même instant). */
  /* LOT v4 · RETOUR G · SOUS 760 PX, LA REVELATION REPASSE PAR L'OBSERVATEUR
     MEME QUAND `view()` EXISTE. La raison complete est ecrite dans
     `casemira-home.css`, au geste 1, avec les mesures. En deux lignes : sur un
     ecran de 844 px, la plage `entry 4 % → cover 18 %` etale la montee de
     16 px sur 280 px de defilement ; la carte de texte du fait main a six
     enfants empiles sur 543 px, leurs six plages se suivent, et le bloc derive
     donc pendant 840 px de defilement a cote d'une video qui, elle, ne bouge
     pas. C'est le « saut » filme par Raph le 06/09 a 23 h 01.
     Le seuil est celui de la parallaxe, pas un second seuil : la page n'a
     qu'une frontiere. `.se-pose` reste sur `view()` quand il existe - il prend
     `scale`, il ne deplace rien verticalement, il ne peut pas deriver.
     La mesure est faite au chargement : une rotation de telephone qui
     franchirait les 760 px laisserait un bloc dans l'autre regime. Le cas est
     inoffensif (l'element est deja revele ou encore sous le pli) et le
     mesurer en continu couterait un ecouteur de redimensionnement pour rien. */
  /* LOT v11, POINT 2a (Raph, 08/09 17 h 08) · LA REVELATION RENONCE A `view()`
     PARTOUT, ET LA PAGE N'A PLUS QU'UNE HORLOGE.
     Le lot v4 l'avait deja fait sous 760 px parce que `view()` y ETALAIT le
     geste. On trouve ici l'autre moitie du meme defaut : sur ordinateur,
     `view()` ne le FINIT pas. Mesure `c7h-v11-diag6.mjs` a 1320 x 860 : qui
     s'arrete de defiler avant `cover 18 %` laisse la sous-ligne des
     best-sellers 10,32 px trop bas et a 35 % d'opacite, indefiniment, pendant
     que les cartes - qui, elles, passent par cet observateur - sont arrivees.
     La sous-ligne se retrouve 6,3 px DANS la premiere carte, qui se peint
     par-dessus : c'est le recouvrement de la capture du collaborateur.
     `[data-reveal]` et `.rev` passent donc TOUJOURS par l'observateur, comme
     `[data-cascade]` depuis le lot v3 et pour la meme raison de fond : une
     entree commence et finit. `.se-pose` garde `view()` quand il existe : il
     prend `scale`, il ne deplace rien, il ne peut ni deriver ni recouvrir. */
  var repli = ', [data-reveal], .rev' + (natif ? '' : ', .se-pose');
  var cibles = qsa('h2.tt, .forme, .repart, .garanties, .manif, [data-cascade]' + repli);
  if ('IntersectionObserver' in window && cibles.length) {
    var io = new IntersectionObserver(function (entrees) {
      entrees.forEach(function (en) {
        if (!en.isIntersecting) return;
        en.target.classList.add(en.target.matches('h2.tt') ? 'compose' : 'est-vu');
        if (en.target.classList.contains('manif')) en.target.classList.add('vu');
        io.unobserve(en.target);
      });
    }, { rootMargin: '0px 0px -10% 0px', threshold: 0.1 });
    cibles.forEach(function (c) { io.observe(c); });

    /* ── LE FILET DU SAUT INSTANTANE (relecture de nuit, reserve) ──────────
       Un observateur ne rapporte que ce qui ENTRE dans la fenetre. Un bloc
       enjambe d'un coup - un lien d'ancre vers le bas de page, la restauration
       de position au retour arriere, un `scrollTo` sans defilement continu -
       n'entre jamais : il reste a son opacite de repos, au-dessus du pli, et
       la cliente ne le retrouve qu'en remontant.
       Le filet ne remplace pas l'observateur, il le complete : il marque comme
       vu tout ce qui est DEJA au-dessus du bas de la fenetre, c'est-a-dire tout
       ce qui a ete traverse ou atteint. Il tourne aux trois moments ou une
       position peut avoir saute sans defilement : la fin du chargement, le
       retour dans l'historique (`pageshow`), et le changement d'ancre. */
    var restants = cibles.slice();
    var filet = function () {
      var vh = window.innerHeight || 0;
      var reste = [];
      for (var i = 0; i < restants.length; i++) {
        var c = restants[i];
        if (c.classList.contains('est-vu') || c.classList.contains('compose')) continue;
        if (c.getBoundingClientRect().top >= vh) { reste.push(c); continue; }  /* encore sous le pli */
        c.classList.add(c.matches('h2.tt') ? 'compose' : 'est-vu');
        if (c.classList.contains('manif')) c.classList.add('vu');
        io.unobserve(c);
      }
      restants = reste;
      /* Plus rien a rattraper : on rend la main pour de bon. */
      if (!restants.length) {
        window.removeEventListener('scroll', apresDefilement);
        window.removeEventListener('load', filet);
        window.removeEventListener('pageshow', filet);
        window.removeEventListener('hashchange', filet);
      }
    };
    /* IL FAUT AUSSI LE DEFILEMENT, ET IL FAUT LE DIFFERER. Un lien d'ancre
       emet `hashchange`, un retour arriere `pageshow` ; mais un `scrollTo`
       instantane n'emet ni l'un ni l'autre, et c'est le cas que la relecture a
       relevé. On repasse donc 150 ms APRES l'arret du defilement - jamais
       pendant : la liste ne se lit pas a chaque image, elle se lit une fois le
       geste fini, et elle se vide au fur et a mesure. */
    var tFilet = null;
    function apresDefilement() {
      clearTimeout(tFilet);
      tFilet = setTimeout(filet, 150);
    }
    window.addEventListener('scroll', apresDefilement, { passive: true });
    window.addEventListener('load', filet);
    window.addEventListener('pageshow', filet);
    window.addEventListener('hashchange', filet);
    /* Au cas ou le document soit deja charge quand ce fichier s'execute. */
    if (document.readyState === 'complete') setTimeout(filet, 0);
  } else {
    cibles.forEach(function (c) {
      c.classList.add(c.matches('h2.tt') ? 'compose' : 'est-vu');
      c.classList.add('vu');
    });
  }

  /* --------------------------------------------------------------- RAILS
     Les flèches sont SUR les bords du rail, à mi-hauteur des VISUELS. La
     hauteur n'est pas écrite en dur : elle est relevée sur le premier visuel
     (`data-rail-mesure`), parce qu'une carte produit porte un cartel sous la
     photo et que « la moitié de la carte » y tomberait dans le texte. */

  /* LOT v9, POINT 9 (Raph, 08/09) · « LES CINQ FORMES : RAIL AVEC POINTS DE
     POSITION, LE MEME INDICATEUR QUE LES AUTRES RAILS. »
     Le rail des formes n'est pas un `.rail` : c'est une grille de cinq colonnes
     sur ordinateur, qui devient un rail sous 768 px. Ce gestionnaire cherchait
     `.rail` en dur ; il accepte desormais un selecteur pose sur la zone. Rien
     n'est duplique : les cinq formes recoivent LA jauge de la page, avec ses
     segments cliquables et son etat « vu », pas un second dessin de points. */
  qsa('[data-rail-zone]').forEach(function (zone) {
    var rail = zone.querySelector(zone.dataset.railCible || '.rail');
    if (!rail) return;
    var cartes = [].slice.call(rail.children);
    if (!cartes.length) return;

    function bouton(dir, libelle, glyphe) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'rail-fl rail-fl--' + (dir < 0 ? 'g' : 'd');
      b.setAttribute('aria-label', libelle);
      b.innerHTML = '<span>' + glyphe + '</span>';
      b.addEventListener('click', function () {
        var pas = cartes[0].getBoundingClientRect().width + 14;
        rail.scrollBy({ left: pas * dir, behavior: doux.matches ? 'auto' : 'smooth' });
      });
      zone.appendChild(b);
      return b;
    }
    /* Les deux libellés viennent des clés `casemira.a11y.cartes_precedentes`
       et `casemira.a11y.cartes_suivantes`, posées par le Liquid sur la zone.
       Le repli n'est pas un texte français : c'est l'absence de libellé, qui
       vaut mieux qu'un mot de la mauvaise langue sur /en. */
    var fg = bouton(-1, zone.dataset.libGauche || '', SVG_G);
    var fd = bouton(1, zone.dataset.libDroite || '', SVG_D);

    var jauge = document.createElement('div');
    jauge.className = 'rail-jauge';
    jauge.setAttribute('aria-hidden', 'true');
    /* LOT v12, POINT 1 · LA JAUGE COMPTE DEPUIS LA BOITE DE CONTENU DU RAIL.
       `offsetLeft` se mesure depuis la boite de BORDURE ; un rail qui porte un
       rembourrage en ligne (c'est le cas de `rail--halo`, qui fait la place de la
       marge blanche du survol) verrait donc chaque segment le porter en trop, et
       la jauge garerait la carte quinze pixels a gauche de sa place. On retire ce
       rembourrage, lu sur la feuille servie et non devine : sans lui, le calcul
       reste celui d'avant au pixel pour tous les autres rails. */
    function rembourrageGauche() {
      var v = parseFloat(getComputedStyle(rail).paddingLeft);
      return isNaN(v) ? 0 : v;
    }
    cartes.forEach(function (c) {
      var seg = document.createElement('i');
      seg.addEventListener('click', function () {
        rail.scrollTo({ left: c.offsetLeft - rail.offsetLeft - rail.clientLeft - rembourrageGauche(), behavior: doux.matches ? 'auto' : 'smooth' });
      });
      jauge.appendChild(seg);
    });
    zone.appendChild(jauge);
    var segments = [].slice.call(jauge.children);

    function placer() {
      var sel = rail.dataset.railMesure;
      var visuel = sel ? cartes[0].querySelector(sel) : null;
      if (!visuel) { zone.style.removeProperty('--fl-y'); return; }
      var y = visuel.getBoundingClientRect().top - zone.getBoundingClientRect().top
            + visuel.getBoundingClientRect().height / 2;
      zone.style.setProperty('--fl-y', Math.round(y) + 'px');
    }

    function majorer() {
      var max = rail.scrollWidth - rail.clientWidth;
      fg.hidden = rail.scrollLeft <= 2;
      fd.hidden = rail.scrollLeft >= max - 2;
      var g = rail.getBoundingClientRect();
      cartes.forEach(function (c, i) {
        var r = c.getBoundingClientRect();
        segments[i].classList.toggle('vu', r.left < g.right - 4 && r.right > g.left + 4);
      });
    }

    /* ── LOT v11, POINT 2c (Raph, 08/09 17 h 08) · LA PREMIERE CARTE EST
       ROGNEE A GAUCHE SUR LA CAPTURE DU COLLABORATEUR ────────────────────────
       Le rail est une boite de defilement, et une boite de defilement a une
       MEMOIRE : Safari restitue la position de chaque conteneur au rechargement,
       au retour dans l'historique et a la restauration d'onglet. Un rail garé
       hors de zero se retrouve donc ainsi au chargement suivant, sans que
       personne ne l'ait touche cette fois-la, et la premiere carte s'ouvre par
       le milieu de son nom.
       Ce filet ne prend jamais la main sur la visiteuse : des qu'elle touche le
       rail - doigt, souris, roulette, clavier, fleche ou jauge - le rail est
       marque et le filet se retire pour de bon. Il ne s'applique donc qu'a une
       position dont PERSONNE, dans cette visite, n'est l'auteur.
       Mesure de reference (`c7h-v11-diag7.mjs`) : au repos, la premiere carte
       est a 0,00 px de la marge du titre sur 62 largeurs de 700 a 1920 px. Le
       filet garantit que c'est aussi vrai a l'arrivee sur la page. */
    var touche = function () { rail.dataset.cmTouche = '1'; };
    ['pointerdown', 'wheel', 'keydown', 'touchstart'].forEach(function (ev) {
      rail.addEventListener(ev, touche, { passive: true });
    });
    fg.addEventListener('click', touche);
    fd.addEventListener('click', touche);
    segments.forEach(function (seg) { seg.addEventListener('click', touche); });
    var remise = function () { if (!rail.dataset.cmTouche && rail.scrollLeft) { rail.scrollLeft = 0; majorer(); } };

    rail.addEventListener('scroll', majorer, { passive: true });
    window.addEventListener('resize', function () { placer(); majorer(); });
    if ('ResizeObserver' in window) new ResizeObserver(placer).observe(rail);
    placer(); majorer(); remise();
    window.addEventListener('load', function () { placer(); majorer(); remise(); });
    window.addEventListener('pageshow', remise);
  });

  /* Le tirage a la souris et le passage en `eager`, pour les rails de cette
     racine. Les autres familles de l'accueil sont servies par
     `casemira-home-motion.js`, a sa place d'hier. */
  qsa('.rail').forEach(tirer);
  qsa('.rail').forEach(eager);

  }
})();
